// Lightweight documents for "My Documents". You can swap this for Markdown later.

export const DOCUMENTS = [
  {
    id: 'welcome',
    title: 'Welcome to My Documents',
    excerpt: 'A quick note about how this section works.',
    body: `This space is yours. Drop short posts, ideas, snippets.

Each doc is a plain JS object in src/content/documents.js with:
- id, title, excerpt, body (string), date (optional), tags (optional).

You can move to Markdown later and parse it, but this keeps it simple and fast.`,
    tags: ['intro'],
    date: '2025-11-08',
  },
  {
    id: 'ideas',
    title: 'Ideas (Scratchpad)',
    excerpt: 'A few sparks worth exploring.',
    body: `- "Explorer" view for domains—search, sort, and star favorites.
- Dynamic backgrounds with palettes from the current track.
- Micro-interactions: pixel shadows, CRT scanlines toggle, sound FX.`,
    tags: ['ideas'],
  },
];
